import { useQuery } from '@tanstack/react-query'

import { aspidaClient } from '@/lib/aspida'
import { QueryConfig } from '@/lib/react-query'

import { userKeyFactory } from './key'

const getMe = () => {
  return aspidaClient.v1.employee.me.$get()
}

export type UseMeOptions = {
  config?: QueryConfig<typeof getMe>
}

export const useMe = ({ config }: UseMeOptions) => {
  const queryConfig: QueryConfig<typeof getMe> = {
    ...config,
    queryKey: userKeyFactory.me(),
    queryFn: () => getMe(),
  }
  return useQuery(queryConfig)
}
